import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bleach",
  "use": "bleach-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"bleach\"><path d=\"M23.92 20.3L17.3 8.83l5.14-5.14-.8-.8-4.93 4.92L12.49.5a.59.59 0 00-1 0l-4.2 7.31-4.93-4.92-.8.8L6.7 8.83.08 20.3a.53.53 0 000 .57.56.56 0 00.49.28h2.8L1.56 23l.8.81L5 21.15h14l2.62 2.61.8-.8-1.81-1.81h2.8a.56.56 0 00.49-.28.53.53 0 00.02-.57zM12 1.92l3.88 6.72L12 12.52 8.12 8.64zM1.55 20l6-10.36 3.67 3.67L4.51 20zm4.56 0L12 14.13 17.89 20zm13.38 0l-6.69-6.67 3.67-3.67 6 10.36z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol